import { InlineMath, BlockMath } from "react-katex";
import GraphViewer from "../../../../components/GraphPlotter/GraphViewer";
import SelectInput from "../../../../components/inputs/SelectInput";

// losowanie a i b z [-3, 3] (w tym 0)
function losuj() {
  const rand = () => Math.floor(Math.random() * 7) - 3; // [-3..3]
  return { a: rand(), b: rand() };
}

export function generateTask() {
  const { a, b } = losuj();

  const encode = (v) => (v < 0 ? "< 0" : v === 0 ? "= 0" : "> 0");

  return {
    type: "LinearSignFromGraphTask",
    data: {
      a,
      b,
      correctAnswer: {
        a: encode(a),
        b: encode(b),
      },
    },
  };
}

export function renderTask({ data }) {
  const { a, b } = data;

  return (
    <div className="space-y-2">
      <p>
        Na wykresie przedstawiono funkcję liniową{" "}
        <InlineMath math="f(x)=ax+b" />.
      </p>

      <div style={{ maxWidth: 360 }}>
        <GraphViewer
          width={360}
          equations={[`y = ${a}*x + (${b})`]}
          points={{}}
          segments={[]}
          xRange={[-6, 6]}
          yRange={[-6, 6]}
        />
      </div>

      <p>
        Określ znak współczynnika <InlineMath math="a" /> oraz wyrazu wolnego{" "}
        <InlineMath math="b" />.
      </p>
    </div>
  );
}

export function renderInput(_task, userInput, setUserInput, disabled) {
  const opts = [
    { value: "< 0", label: "< 0" },
    { value: "= 0", label: "= 0" },
    { value: "> 0", label: "> 0" },
  ];

  return (
    <div className="mt-4">
      <div style={{ maxWidth: "350px", marginBottom: "1rem", opacity: disabled ? 0.6 : 1 }}>
        <label className="flex items-center gap-2">
          <InlineMath math="a\text{:}" />
          <SelectInput
            value={userInput?.a || ""}
            onChange={(e) => setUserInput({ ...userInput, a: e.target.value })}
            options={opts}
            disabled={disabled}
          />
        </label>
      </div>

      <div style={{ maxWidth: "350px", opacity: disabled ? 0.6 : 1 }}>
        <label className="flex items-center gap-2">
          <InlineMath math="b\text{:}" />
          <SelectInput
            value={userInput?.b || ""}
            onChange={(e) => setUserInput({ ...userInput, b: e.target.value })}
            options={opts}
            disabled={disabled}
          />
        </label>
      </div>
    </div>
  );
}

export function checkAnswer(task, userInput) {
  const { a, b } = task.data;

  const encode = (v) => (v < 0 ? "< 0" : v === 0 ? "= 0" : "> 0");

  const expected = {
    a: encode(a),
    b: encode(b),
  };

  const signMap = { "< 0": -1, "= 0": 0, "> 0": 1 };

  const isCorrect =
    signMap[userInput?.a] === signMap[expected.a] &&
    signMap[userInput?.b] === signMap[expected.b];

  return {
    isCorrect,
    expected,
    actual: userInput,
    comment: null,
  };
}

export function renderAnswer({ data }) {
  const sign = (v) => (v < 0 ? "< 0" : v === 0 ? "= 0" : "> 0");

  return (
    <div style={{ marginTop: "0.5rem" }}>
      <div style={{ display: "flex", gap: "1.5rem", marginBottom: "1rem" }}>
        <InlineMath math={`a ${sign(data.a)}`} />
        <InlineMath math={`b ${sign(data.b)}`} />
      </div>
    </div>
  );
}

export function renderExplanation({ data }) {
  const sign = (v) => (v > 0 ? "> 0" : v < 0 ? "< 0" : "= 0");

  return (
    <div className="space-y-2">
      <p>
        Z wykresu odczytujemy nachylenie prostej (to mówi o znaku{" "}
        <InlineMath math="a" />) oraz punkt przecięcia z osią{" "}
        <InlineMath math="Oy" /> (to mówi o znaku <InlineMath math="b" />
        ).
      </p>

      <ul className="list-disc list-inside">
        <li>
          Jeśli wykres rośnie, to <InlineMath math="a>0" />; jeśli maleje, to{" "}
          <InlineMath math="a<0" />; jeśli jest poziomy, to{" "}
          <InlineMath math="a=0" />.
        </li>
        <li>
          Jeśli przecina oś <InlineMath math="Oy" /> powyżej zera, to{" "}
          <InlineMath math="b>0" />; poniżej zera to <InlineMath math="b<0" />;
          jeśli w punkcie <InlineMath math="(0,0)" />, to{" "}
          <InlineMath math="b=0" />.
        </li>
      </ul>

      <p>W tym przypadku:</p>
      <BlockMath math={`a ${sign(data.a)},\\quad b ${sign(data.b)}`} />
    </div>
  );
}

export function renderUserAnswer(_task, userAnswer) {
  if (!userAnswer?.a || !userAnswer?.b) return <i>(brak odpowiedzi)</i>;

  return (
    <div style={{ display: "flex", gap: "1.5rem", marginTop: "0.5rem" }}>
      <InlineMath math={`a ${userAnswer.a}`} />
      <InlineMath math={`b ${userAnswer.b}`} />
    </div>
  );
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};
